"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Step_1 = __importDefault(require("./Step"));
class ProvidersStep extends Step_1.default {
    constructor(config) {
        super(config.id);
        this.data = config.data;
    }
    addFields(fields) {
        fields.forEach((field, index) => {
            if (field.geodata.length > 0)
                field.updateSize();
            field.id = index;
            if (!field.fieldName || field.fieldName.trim().length === 0) {
                field.fieldName = ``;
                this.data.fields.push(field);
            }
            else {
                let uniqueFieldName = field.fieldName;
                let fieldCounter = 1;
                while (this.data.fields.some(existingField => existingField.fieldName === uniqueFieldName)) {
                    uniqueFieldName = `${field.fieldName}_${fieldCounter}`;
                    fieldCounter++;
                }
                field.fieldName = uniqueFieldName;
                this.data.fields.push(field);
            }
        });
    }
    resetFields() {
        this.data.fields = [];
    }
    addSelectedFields(field) {
        this.data.selectedFields.push(field);
    }
    resetSelectedFields() {
        this.data.selectedFields = [];
    }
    removeSelectedField(fieldId) {
        this.data.selectedFields = this.data.selectedFields.filter(field => field.id !== fieldId);
    }
}
exports.default = ProvidersStep;
